const env = process.env.NODE_ENV
// var url = 'https://train.aojuai.com/ajdataother';
var url = 'http://192.168.2.75:19091/ajdataother'; 
// 新服务
const config = {
  development:{
    // baseURL :url//本
    baseURL :url, //线上 
   
  },
  production:{
     baseURL :'https://train.aojuai.com/ajdataother',

  }
}
export default {  
  baseURL:config[env].baseURL,
}